
  // src/utils/validationHelpers.js

// ✅ Phone number validation (basic global/local pattern)
export function isValidPhone(phone) {
    const pattern = /^(\+?\d{1,4}[-\s]?)?(\(?\d{2,4}\)?[-\s]?)?[\d\s-]{5,15}$/;
    return pattern.test(phone);
  }
  
  // ✅ Email validation
  export function isValidEmail(email) {
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return pattern.test(email);
  }
  
  // ✅ Password validation
  // At least 8 characters, with at least one letter and one number
  export function isValidPassword(password) {
    const pattern = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d@$!%*?&]{8,}$/;
    return pattern.test(password);
  }
  
  